let state = {
  
    gradecurricular:[],
    dados_gradecurricular:{},
    lista_grade_oferta_disciplina:[],
    Setargradecurricular:{}

}

export default state